// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_74-4";
export var collapsed = "_74-1";
export var headerBar = "_74-0";
export var leftHeaderContent = "_74-3";
export var subjectContainer = "_74-2";